import React from 'react';
import { css } from '@emotion/core';
import useScrollElementOnMount from 'client/hooks/useScrollElementOnMount';
import Popup from 'client/components/Popup';
import { Typography } from '@material-ui/core';
import { PointSystemPoints } from 'client/components/dialogVerification/dialogDeductPoint/DialogDeductPoint';
import i18next from 'i18next';

export default function DialogDeductFailed({ open, onClose = () => {}, handleSubmit }) {
    const bindRef = useScrollElementOnMount();

    return (
        <>
            <Popup
                isOpen={open}
                title={'label.unqualified'}
                onClose={onClose}
                startButton={'btn.close'}
                endButton={'btn.try_again'}
                onConfirm={handleSubmit}
                disableBackdropClick
            >
                <div css={dialogContentStyle} ref={bindRef}>
                    <div css={descStyle}>
                        <Typography variant="subtitle2">
                            {i18next.t('label.please_confirm')}
                        </Typography>
                        <PointSystemPoints pointSize={14} needShowPoint={false} />
                        <Typography variant="subtitle2">
                            {i18next.t('label.is_it_enough')}
                        </Typography>
                    </div>
                </div>
            </Popup>
        </>
    );
}

const dialogContentStyle = css`
    padding: 16px;
    text-align: center;
`;

const descStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;
`;
